var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSportSnooker24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_sport_snooker24x24",
    d: "M16.914,14.83a1.49,1.49,0,1,0,1.5,1.49h0A1.469,1.469,0,0,0,16.914,14.83Zm0,0a1.49,1.49,0,1,0,1.5,1.49h0A1.469,1.469,0,0,0,16.914,14.83Zm-2.5-3.577a1.49,1.49,0,1,0,1.5,1.49h0a1.411,1.411,0,0,0-1.5-1.49Zm0,0a1.49,1.49,0,1,0,1.5,1.49h0a1.411,1.411,0,0,0-1.5-1.49Zm-4.8,0a1.557,1.557,0,0,0-1.6,1.49,1.5,1.5,0,0,0,3,0h0a1.387,1.387,0,0,0-1.4-1.49Zm0,0a1.557,1.557,0,0,0-1.6,1.49,1.5,1.5,0,0,0,3,0h0a1.387,1.387,0,0,0-1.4-1.49Zm2.4,3.577a1.49,1.49,0,1,0,1.5,1.49h0A1.413,1.413,0,0,0,12.009,14.83Zm0,0a1.49,1.49,0,1,0,1.5,1.49h0A1.413,1.413,0,0,0,12.009,14.83Zm0-7.154a1.49,1.49,0,1,0,1.5,1.49h0A1.469,1.469,0,0,0,12.009,7.677Zm0,0a1.49,1.49,0,1,0,1.5,1.49h0A1.469,1.469,0,0,0,12.009,7.677ZM7.1,14.83a1.49,1.49,0,1,0,1.5,1.49h0A1.364,1.364,0,0,0,7.1,14.83Zm0,0a1.49,1.49,0,1,0,1.5,1.49h0A1.364,1.364,0,0,0,7.1,14.83ZM18.816,20.1H5.2A2.214,2.214,0,0,1,3,17.91a1.992,1.992,0,0,1,.3-1.093L10.107,5.193a2.179,2.179,0,0,1,3-.795,3.035,3.035,0,0,1,.8.795l6.807,11.625a2.209,2.209,0,0,1-.8,2.981,2.029,2.029,0,0,1-1.1.3ZM12.009,4.8a1.39,1.39,0,0,0-1.2.7L4,17.215A1.328,1.328,0,0,0,4.5,19.1a1.866,1.866,0,0,0,.7.2H18.816a1.363,1.363,0,0,0,1.4-1.391,1.428,1.428,0,0,0-.2-.7L13.21,5.491a1.39,1.39,0,0,0-1.2-.7Z",
    transform: "translate(-3 -4.096)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSportSnooker24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_sport_snooker24x24.1d1d4697062eb6ead474caf483b41ba9.svg";